import { Box, Stack, Typography } from '@mui/material';
import { MediumTypography } from '@components/modals/BulkEditModal/components/ReviewEditsPage/components/MediumTypography';
import { useGetAllCreatives } from '@components/hooks/apis/creatives';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useTheme } from '@mui/material/styles';
import { Creative } from '@local-types';
export const CreativeListRenderer = ({
  creatives,
  color,
  direction = 'from',
}: {
  creatives: number[] | Creative[];
  color?: string;
  direction?: 'from' | 'to';
}) => {
  const theme = useTheme();
  const { items: library } = useGetAllCreatives();

  // The creatives can be an array of ids or an array of creatives
  if (creatives?.length > 0 && typeof creatives[0] === 'number') {
    creatives = creatives.map(id => library.find(c => c.id === id));
  }

  if (creatives.length === 0) {
    return <MediumTypography text={'None'} color={color} />;
  }

  return (
    <Stack direction="row" spacing={2}>
      <Stack spacing={2}>
        {(creatives as Creative[]).map(creative => {
          return direction === 'from' ? (
            <Typography
              key={creative?.id}
              variant="body2"
              sx={{ textDecoration: 'line-through' }}
            >
              {creative?.name}
            </Typography>
          ) : (
            <MediumTypography text={creative?.name} color={color} />
          );
        })}
      </Stack>
      {direction === 'from' && (
        <Box sx={{ flexShrink: 0 }}>
          <FontAwesomeIcon
            icon={faArrowRight}
            fontSize="20px"
            color={theme.palette.grey[9]}
          />
        </Box>
      )}
    </Stack>
  );
};
